export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_logistics-command-83/artifacts/5arf3s05_Screenshot%202026-04-14%20113623.png";

export const HERO_SHIP =
  "https://images.unsplash.com/photo-1699589080655-f00497141852?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxjb250YWluZXIlMjBzaGlwJTIwYWVyaWFsJTIwZHJvbmV8ZW58MHx8fHwxNzgzMjg3NDk5fDA&ixlib=rb-4.1.0&q=85";

export const WAREHOUSE_IMG =
  "https://images.pexels.com/photos/11666903/pexels-photo-11666903.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const HIGHWAY_TRUCK =
  "https://images.pexels.com/photos/6563903/pexels-photo-6563903.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const OFFICE_MANAGER =
  "https://images.unsplash.com/photo-1560264280-88b68371db39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3MlMjBtYW5hZ2VyJTIwb2ZmaWNlfGVufDB8fHx8MTc4MzI4NzQ5OXww&ixlib=rb-4.1.0&q=85";

export const COMPANY = {
  name: "Apex Supply Chain Solutions",
  short: "APEX",
  tagline: "Supply Chain Solutions",
  address: "3200 E Broadway, Vancouver, BC V5M 1Z8",
  phone: "778-861-7890",
  email: "supplychain@apexscs.ca",
};

export const CURRENCIES = [
  { key: "USD", label: "USD", symbol: "$" },
  { key: "CAD", label: "CAD", symbol: "C$" },
];

export const currencySymbol = (c) =>
  CURRENCIES.find((x) => x.key === c)?.symbol || "$";

export const PIECES_UNITS = ["Pallets", "Pieces", "Boxes", "Skids", "Cartons"];

export const ACCESSORIAL_OPTIONS = [
  "Fuel Surcharge",
  "Detention",
  "Layover",
  "TONU",
  "Lumper Fee",
  "Liftgate",
  "Residential Delivery",
  "Appointment Fee",
  "Border Crossing",
  "Oversize/Overweight",
  "Other",
];

export const EQUIPMENT_OPTIONS = [
  "Dry Van",
  "Reefer",
  "Flatbed",
  "Step Deck",
  "Container",
  "Box Truck",
  "Straight Truck",
  "Cargo Van",
  "Sprinter Van",
  "Power Only",
  "Hotshot",
  "Double Drop",
  "Lowboy",
  "RGN",
  "Curtain Side",
  "Tanker",
  "Intermodal",
];

export const COMMODITY_OPTIONS = [
  "General Freight",
  "Food & Beverages",
  "Produce",
  "Consumer Goods",
  "Retail Merchandise",
  "Automotive Parts",
  "Building Materials",
  "Machinery & Equipment",
  "Electronics",
  "Furniture",
  "Paper Products",
  "Steel & Metal",
  "Chemicals (Non-Hazardous)",
  "Hazardous Materials (Hazmat)",
];

export const JOB_STATUSES = [
  { key: "requested", label: "Requested" },
  { key: "quoted", label: "Quoted" },
  { key: "scheduled", label: "Scheduled" },
  { key: "in_transit", label: "In Transit" },
  { key: "delivered", label: "Delivered" },
  { key: "invoiced", label: "Invoiced" },
  { key: "cancelled", label: "Cancelled" },
];

export const statusLabel = (s) =>
  JOB_STATUSES.find((x) => x.key === s)?.label || s;

export const statusColor = (s) => {
  switch (s) {
    case "requested":
      return "bg-amber-100 text-amber-900 border-amber-300";
    case "quoted":
      return "bg-blue-100 text-blue-900 border-blue-300";
    case "scheduled":
      return "bg-indigo-100 text-indigo-900 border-indigo-300";
    case "in_transit":
      return "bg-sky-100 text-sky-900 border-sky-300";
    case "delivered":
      return "bg-emerald-100 text-emerald-900 border-emerald-300";
    case "invoiced":
      return "bg-zinc-900 text-white border-zinc-900";
    case "cancelled":
      return "bg-rose-100 text-rose-900 border-rose-300";
    default:
      return "bg-zinc-100 text-zinc-900 border-zinc-300";
  }
};
